import { render, staticRenderFns } from "./fitment-plus-add-edit.vue?vue&type=template&id=36ea4b40&scoped=true&"
import script from "./fitment-plus-add-edit.vue?vue&type=script&lang=js&"
export * from "./fitment-plus-add-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea4b40",
  null
  
)

export default component.exports